import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomTable from "../../components/CustomTable";
import { faFileInvoice, faUsersBetweenLines } from "@fortawesome/free-solid-svg-icons";
import "../CaseDetails/CaseDetails.css";
import { useState , useEffect } from "react";
import API from "../../api/axiosConfig";
import TableComponent from "../../components/TableComponent";

function AddMinutesReport(params) {

    const columns = [
        { name: "عنوان المحضر", key: "title" },
        { name: "تاريخ المحضر", key: "date" },
        { name: "ملاحظات", key: "note" },
        { name: "نوع الاجتماع", key: "type" },
        { name: "عرض المستندات", key: "upload" },
        { name: "", key: "actions" },
    ];


    const [rows, setRows] = useState([]);
    const [error, setError] = useState([]);
    const [loading, setLoading] = useState(true);

    // const getMinutes = async () => {
    //     try {
    //         const res = await API.get("/minutesheets");
    //         const data = await res;
    //         if (data.status === 200) {
    //             setRows(data.data);
    //             setLoading(false);
    //         }
    //     } catch (error) {
    //         console.error(error);
    //         setError(error.response.data.errors);
    //     }
    // };

    // useEffect(() => {
    //     getMinutes();
    // }, []);

    const dropdownOptions = [
        { label: "تعديل", route: "/editAddMinutes/:id" },
      ];

    const handleDownload = (selectedRows) => {
        const selectedData = rows.filter((row) => selectedRows.includes(row.id));
        if (selectedData.length === 0) {
            alert("Please select at least one row.");
            return;
        }

        const csvHeader = columns
            .filter((col) => col.key !== "actions")
            .map((col) => col.name)
            .join(",");

        const csvRows = selectedData.map((row) =>
            columns
                .filter((col) => col.key !== "actions")
                .map((col) => `"${row[col.key] || ""}"`)
                .join(",")
        );

        const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

        const bom = "\uFEFF";
        const finalContent = bom + csvContent;

        const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", "selected_rows_report.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const modifyRow = (row) => {
       let newRow = { ...row };
        newRow.upload = newRow.upload !== null && newRow.upload !== undefined && newRow.upload !== "" ? (`<a class="" href="${newRow.upload}" target="_blank"> 👁️</a>`) : "لا يوجد مستندات";
        return newRow;
    }

    return (
        <>
            <div className="printcasedata-container">

                
                <TableComponent
                    apiUrl="/minutesheets"
                    columns={columns}
                    title="تقرير المحاضر"
                    titleIcon={<FontAwesomeIcon icon={faFileInvoice} />}
                    dropdownOptions={dropdownOptions}
                    transformRowFn={modifyRow}
                />
            </div>
        </>
    );
}
export default AddMinutesReport
